import { render, staticRenderFns } from "./TextToSpeech.vue?vue&type=template&id=346f16f8&scoped=true"
import script from "./TextToSpeech.vue?vue&type=script&lang=js"
export * from "./TextToSpeech.vue?vue&type=script&lang=js"
import style0 from "./TextToSpeech.vue?vue&type=style&index=0&id=346f16f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f16f8",
  null
  
)

export default component.exports